import { Component, inject, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { getTemperatureType } from '../../../../../helper/temperature';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { NlToBrPipe } from '../../../../../../../pipes/nl-to-br.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p00037-espinstallation-cl',
  templateUrl: './p00037-espinstallation-cl.component.html',
  styleUrls: ['./p00037-espinstallation-cl.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    NlToBrPipe,
    TranslatePipe,
  ],
})
export class P00037ESPInstallationClComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }

  protected readonly getTemperatureType = getTemperatureType;
}
